<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Looking to login?
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <img src="static/img/authentic_net_lt_color.png" width="400" alt="Authentic.net">
                  <h4>Register now to start protecting your products and customers!</h4>
                  <h5 v-if="stripe_plan_fetched">{{this.plan.name}} - ${{ this.plan.amount }} a {{ this.plan.interval }}</h5>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Protect Your Customers!</h5>
                    Give your valued customers the tools they need to verify that the products they purchase are genuine.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="ti-package"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Protect Your Brand &amp; Products</h5>
                    Make it impossible for counterfeiters to pretend their products are authentic.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-info">
                      <i class="ti-headphone"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Fantastic Support</h5>
                    We love our business customers are are here to help you grow!
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form method="#" action="#" @submit.prevent="validateBeforeSubmit()">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="text"
                          name="businessName"
                          v-model="model.businessName"
                          v-validate="modelValidations.businessName"
                          placeholder="Business Name"
                          class="form-control">
                        <small class="text-danger" v-show="businessName.invalid">
                          {{ getError('businessName') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="email"
                          name="email"
                          v-model="model.email"
                          v-validate="modelValidations.email"
                          placeholder="Email"
                          class="form-control">
                        <small class="text-danger" v-show="email.invalid">
                          {{ getError('email') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          name="name"
                          v-model="model.name"
                          v-validate="modelValidations.name"
                          placeholder="Name"
                          class="form-control">
                        <small class="text-danger" v-show="name.invalid">
                          {{ getError('name') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="password"
                          name="password"
                          v-model="model.password"
                          v-validate="modelValidations.password"
                          placeholder="Password"
                          class="form-control">
                        <small class="text-danger" v-show="password.invalid">
                          {{ getError('password') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <input
                          type="password"
                          name="password_confirmation"
                          v-model="model.password_confirmation"
                          v-validate="modelValidations.password_confirmation"
                          placeholder="Password Confirmation"
                          class="form-control">
                        <small class="text-danger" v-show="password_confirmation.invalid">
                          {{ getError('password_confirmation') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <card class='stripe-card'
                          :class='{ complete }'
                          :stripe='stripePubKey'
                          :options='stripeOptions'
                          @change='complete = $event.complete'
                        />
                      </div>
                      <div class="form-group">
                        <input type="text" v-model="model.coupon" placeholder="Coupon Code" class="form-control">
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" @click.prevent="validateBeforeSubmit()" class="btn btn-fill btn-danger btn-wd">Sign Up!</button>
                      <button type="button" v-if="loading" class="btn btn-wd btn-danger" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Sign Up!
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
// import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { uuid } from 'vue-uuid'
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'
import qs from 'qs'
import db from '@/components/firebase/init'
import firebase from 'firebase'
import 'firebase/functions'
import { toolboxMixin } from '@/components/mixins/toolboxMixin'

export default {
  computed: {
    ...mapFields(['businessName',
      'email',
      'name',
      'password',
      'password_confirmation'])
  },
  mixins: [toolboxMixin],
  data () {
    return {
      myvariable: 4,
      modelValidations: {
        businessName: {
          required: true
        },
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true
        }
        // password_confirmation: {
        //   required: true,
        //   confirmed: 'password'
        // }
      },
      stripe_plan_fetched: false,
      loading: false,
      step: 1,
      complete: false,
      stripe_customer_id: '',
      model: {
        businessName: '',
        name: '',
        email: '',
        coupon: '',
        password: '',
        password_confirmation: '',
        stripe_token: '',
        plan_id: '',
        stripeCustomerId: ''
      },
      plan: {
        id: 'plan_EcLp2TZFiDcRdB',
        name: '',
        amount: '',
        interval: ''
      },
      stripePubKey: process.env.STRIPE_PUB_KEY,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
        classes: {
          base: 'form-control'
        }
      },
      apiBaseUrl: process.env.API_BASE_URL
    }
  },

  components: { Card },

  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    submit () {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then((data) => {
        if (data.error) {
          swal.fire({
            title: 'Error',
            text: data.error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        } else {
          console.log('stripe token')
          console.log(data.token.id)
          this.model.stripe_token = data.token.id
          // alert(this.model.stripe_token)
          this.signup()
          // this.createStripeSubscription(data.token.id)
          // this.loading = false
        }
      })
    },
    signup () {
      console.log('signing up')
      let signup = firebase.functions().httpsCallable('signup')
      signup(this.model)
      .then(result => {
        console.log(result)
        swal.fire({
          title: `Welcome!`,
          text: 'Your account was successfully created! Please proceed to login.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(() => {
          this.loading = false
          this.$router.replace('/login')
        })
      })
      .catch(err => {
        console.error(err.message)
      })
      // firebase.auth().createUserWithEmailAndPassword(this.model.email, this.model.password)
      // .then(cred => {
      //   db.collection('companies').
      // })
      // .catch(err => {
      //   console.error(err)
      //   swal.fire({
      //     title: 'Error',
      //     text: err.message,
      //     type: 'error',
      //     confirmButtonClass: 'btn btn-info btn-fill',
      //     buttonsStyling: false
      //   })
      //   this.loading = false
      // })
      // axios.post(process.env.ROOT_API + '/v1/signup?' + qs.stringify(this.model), this.axios_config)
      // .then((response) => {
      //   console.log(response)
      //   swal.fire({
      //     title: `Welcome!`,
      //     text: 'Your account was successfully created! Please proceed to login.',
      //     buttonsStyling: false,
      //     confirmButtonClass: 'btn btn-success btn-fill',
      //     type: 'success'
      //   }).then(() => {
      //     this.loading = false
      //     this.$router.replace('/login')
      //   })
      // })
      // .catch((error) => {
      //   var errMsg = error.response.data.message
      //   console.log(error.response)
      //   swal.fire({
      //     title: 'Error',
      //     text: errMsg,
      //     type: 'error',
      //     confirmButtonClass: 'btn btn-info btn-fill',
      //     buttonsStyling: false
      //   })
      //   /*
      //   var keys = Object.keys(error.response.data.data)
      //   keys.forEach((key) => {
      //     var values = error.response.data.data[key]
      //     console.log('key')
      //     console.log(key)
      //     console.log('values')
      //     console.log(values)
      //     errMsg += ' - ' + values
      //     swal.fire({
      //       title: 'Error',
      //       text: errMsg,
      //       type: 'error',
      //       confirmButtonClass: 'btn btn-info btn-fill',
      //       buttonsStyling: false
      //     })
      //     this.loading = false
      //     // do stuff with "values"
      //   })
      //   */
      //   this.loading = false
      // })
    },
    fetchStripePlan (planId) {
      let getStripePlan = firebase.functions().httpsCallable('getStripePlan')
      getStripePlan({ planId: planId })
      .then(plan => {
        console.log(plan)
        this.model.plan_id = planId
        this.plan.name = plan.data.name
        this.plan.amount = plan.data.amount / 100
        this.plan.interval = plan.data.interval
        this.stripe_plan_fetched = true
      })
      .catch(err => {
        alert(err.message)
      })
      // axios.get('https://api.authentic.net/get_stripe_plan.php?plan_id=plan_' + planId, this.axios_get_config)
      // .then((response) => {
      //   this.model.plan_id = 'plan_' + planId
      //   this.plan.name = response.data.name
      //   this.plan.amount = response.data.amount / 100
      //   this.plan.interval = response.data.interval
      //   this.stripe_plan_fetched = true
      // })
      // .catch((error) => {
      //   console.log(error)
      // })
    },
    beforeDestroy () {
      this.closeMenu()
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateBeforeSubmit () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.submit()
          // this.signup()
        } else {
          this.loading = false
        }
      })
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.query.p) this.plan.id = this.$route.query.p
      this.fetchStripePlan(this.plan.id)
    })
  }
}
</script>

<style>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register.vue